import { aboutFeatures } from "@/mocks/gua";

export default function About() {
  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-archive-drawer-line"></i>关于我们
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              吃瓜中心是谁
            </h2>
            <p className="mt-5 text-sm leading-8 text-foreground-600 md:text-base">
              吃瓜中心是一个专注热点事件梳理的内容站。我们并不满足于把热搜标题罗列一遍，
              而是坚持<span className="font-medium text-primary-600">以热门事件为圆心</span>
              ，向外辐射挖掘关联人物、背景故事与周边衍生瓜，把零散信息整理成一张张可读的瓜田地图。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-600 md:text-base">
              网站定位不是"追着更新"，而是"帮你把一只瓜看完整"。因此在每一只追踪中的热点里，
              我们都尽量标清事实与推断、附上时间线并持续跟进后续声明，
              希望你吃得过瘾的同时，也能保持清醒与独立思考。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {aboutFeatures.map((f) => (
                <div
                  key={f.title}
                  className="flex gap-3 rounded-xl border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${f.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{f.title}</h3>
                    <p className="mt-1 text-xs leading-5 text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <div className="relative h-56 md:h-64">
                <img
                  src="https://readdy.ai/api/search-image?query=cozy%20modern%20newsroom%20editorial%20scene%20with%20warm%20lighting%2C%20scattered%20printed%20headline%20sheets%20and%20a%20central%20glowing%20map%20of%20connected%20stories%2C%20tomato%20red%20and%20cream%20and%20gold%20tones%2C%20flat%20stylized%20illustration&width=900&height=620&seq=about-newsroom&orientation=landscape"
                  alt="吃瓜中心编辑部以热点为圆心整理关联信息的场景"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="bg-background-50 px-6 py-6">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  内容原则：透明 · 克制 · 有始有终
                </h3>
                <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                    <span>区分事实与推断，重要结论尽量标注信息来源。</span>
                  </li>
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                    <span>不跟风站队、不制造对立，把判断空间留给你。</span>
                  </li>
                  <li className="flex gap-3">
                    <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                    <span>反转也要跟进到底，让每一只瓜都有清晰结局。</span>
                  </li>
                </ul>
                <div className="mt-5 flex items-center gap-2 border-t border-background-100 pt-4 text-sm text-foreground-700">
                  <i className="ri-mail-line text-accent-700"></i>
                  合作与投稿：hello@chigua-center.example
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}